import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useState } from "react";
var DEFAULT_WRAP = "lo-picker-input-wrap";
var DEFAULT_LIST = "lo-picker-suggestions";
var DEFAULT_SUGGESTION = "lo-picker-suggestion";
var DEFAULT_ACTIVE = "lo-picker-suggestion-active";
export default function Autocomplete(_a) {
    var inputId = _a.inputId, value = _a.value, placeholder = _a.placeholder, className = _a.className, suggestions = _a.suggestions, _b = _a.showSuggestions, showSuggestions = _b === void 0 ? true : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.ariaInvalid, ariaInvalid = _e === void 0 ? false : _e, _f = _a.wrapClassName, wrapClassName = _f === void 0 ? DEFAULT_WRAP : _f, _g = _a.listClassName, listClassName = _g === void 0 ? DEFAULT_LIST : _g, _h = _a.suggestionClassName, suggestionClassName = _h === void 0 ? DEFAULT_SUGGESTION : _h, _j = _a.activeSuggestionClassName, activeSuggestionClassName = _j === void 0 ? DEFAULT_ACTIVE : _j, onChange = _a.onChange, onSelect = _a.onSelect, onBlur = _a.onBlur, onFocus = _a.onFocus;
    var listId = useId();
    var _k = useState(false), open = _k[0], setOpen = _k[1];
    var _l = useState(-1), highlight = _l[0], setHighlight = _l[1];
    useEffect(function () {
        if (!showSuggestions) {
            setOpen(false);
            setHighlight(-1);
            return;
        }
        setHighlight(suggestions.length ? 0 : -1);
        setOpen(suggestions.length > 0);
    }, [suggestions, showSuggestions]);
    var selectIndex = function (index) {
        var item = suggestions[index];
        if (!item)
            return;
        onSelect(item);
        setOpen(false);
        setHighlight(-1);
    };
    var handleKeyDown = function (e) {
        if (!open || suggestions.length === 0) {
            if (e.key === "Escape")
                setOpen(false);
            return;
        }
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlight(function (i) { return (i + 1) % suggestions.length; });
        }
        else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlight(function (i) { return (i <= 0 ? suggestions.length - 1 : i - 1); });
        }
        else if (e.key === "Enter") {
            if (highlight >= 0) {
                e.preventDefault();
                selectIndex(highlight);
            }
        }
        else if (e.key === "Escape") {
            setOpen(false);
        }
    };
    return (_jsxs("div", { className: wrapClassName, children: [_jsx("input", { id: inputId, type: "text", role: "combobox", "aria-autocomplete": "list", "aria-expanded": open, "aria-controls": listId, "aria-activedescendant": highlight >= 0 ? "".concat(listId, "-").concat(highlight) : undefined, "aria-invalid": ariaInvalid ? "true" : "false", "aria-required": required ? "true" : undefined, required: required, className: className, value: value, placeholder: placeholder, disabled: disabled, autoComplete: "off", autoCorrect: "off", spellCheck: false, onChange: function (e) { return onChange(e.currentTarget.value); }, onKeyDown: handleKeyDown, onFocus: function () {
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus();
                    if (showSuggestions && suggestions.length > 0)
                        setOpen(true);
                }, onBlur: function () {
                    window.setTimeout(function () {
                        setOpen(false);
                        onBlur();
                    }, 120);
                } }), showSuggestions && open && suggestions.length > 0 && (_jsx("ul", { id: listId, className: listClassName, role: "listbox", children: suggestions.map(function (item, i) { return (_jsx("li", { role: "presentation", children: _jsx("button", { type: "button", id: "".concat(listId, "-").concat(i), role: "option", "aria-selected": i === highlight, className: [
                            suggestionClassName,
                            i === highlight ? activeSuggestionClassName : "",
                        ]
                            .filter(Boolean)
                            .join(" "), onMouseDown: function (e) { return e.preventDefault(); }, onClick: function () { return selectIndex(i); }, children: item.label }) }, item.id)); }) }))] }));
}
